import {
  Alert,
  Box,
  Button,
  Chip,
  Container,
  Grid,
  Paper,
  Skeleton,
  Typography
} from '@mui/material'
import PageProps from '../_types/page-props.interface'
import Sidebar from '../components/sidebar'
import VerifyEmailModal from '../components/verify-email'
import { Fragment, useEffect, useState } from 'react'
import { useGlobalState } from '../context/global'
import { useError } from '../context/error'
import { AlertService } from '../services/alert.service'
import { CarnivoreAlert } from '../_types/alert.type'
import { StyleHelper } from '../components/style-helper'
import AlertViewLoadingState from '../components/loading/alert-view.loading'
import ViewAlertModal from '../components/modals/view-alert.modal'
import useBoolean from '../hooks/useBoolean'
import AlertView from '../components/alert-view'
import { ArrowRightAlt, MenuBook } from '@mui/icons-material'
import DASHBOARD_QUICK_LINKS from '../_constants/dashboard-quicklinks'
import DashboardLinkView from '../components/dashbaord-link'
import WelcomeModal from '../components/modals/welcome.modal'
import { UserService } from '../services/user.service'
import { CarnivoreUser } from '../_types/user.type'
import { WrapService } from '../services/wrap.service'
import useGetPortfolioReturns from '../hooks/useGetPortfolioReturns'
import useDocumentTitle from '../hooks/useDocumentTitle'
import CarnivoreLogo from '../components/imgs/carnivore-logo'
import AlertModal from '../components/modals/alert.modal'
import WebPush from '../components/webpush'
import CommentModal from '../components/modals/comment.modal'
import { AnalyticsActions, AnalyticsCategories, AnalyticsHelper } from '../_helpers/analytics.helper'
import { EventService } from '../services/events.service'
import { CarnivoreEvent } from '../_types/carnivore-event.type'
import { er } from '@fullcalendar/core/internal-common'
import { Formatters } from '../_helpers/formatter.helper'
import CarnivoreEventRow from '../components/eventrow'

function PortfolioReturn() {
  const { errorMessage, loading, returnPercentage } = useGetPortfolioReturns()

  return (
    <Fragment>
      <Typography variant='h6' pl={1}>
        Portfolio Return
      </Typography>
      {loading ? (
        <Paper elevation={3} sx={{ m: 1, p: 2 }}>
          <Skeleton variant='text' height={'7rem'} />
        </Paper>
      ) : (
        <Paper elevation={3} sx={{ m: 1, p: 2 }}>
          {errorMessage ? (
            <Typography variant='h4' textAlign={'center'} color={'error'} >
              error
            </Typography>
          ) : (
            <Typography variant='h2' textAlign={'center'}>
              {returnPercentage}% <small>YTD</small>
            </Typography>
          )}
        </Paper>
      )}
    </Fragment>
  )
}

export default function Dashboard(page: PageProps) {
  const [showVerify, setShowVerify] = useState(false)
  const { user, setUser, setShowIntro, banner } = useGlobalState()
  const [showBrowserAlerts, setShowBrowserAlerts] = useState(false)

  const { setError } = useError()

  const alertService = new AlertService(setError)
  const userService = new UserService(setError)
  const eventService = new EventService(setError)

  const [currentAlert, setCurrentAlert] = useState<CarnivoreAlert | null>(null)
  const [events, setEvents] = useState<CarnivoreEvent[]>([])
  const [showWelcome, setShowWelcome] = useState(false)
  const [showAlertModal, { toggle: toggleShowAlertModal }] = useBoolean()
  const [loading, setLoading] = useState(true)

  const [showCommentBox, setShowCommentBox] = useState(false)
  const [showCommentModal, setShowCommentModal] = useState(false)

  useDocumentTitle(page.title)
  useEffect(() => {
    if (user && !user?.isOnboarded) {
      setShowWelcome(true)
    }
    try {
      if (!window.localStorage.getItem('comment-ask')) {
        const now = new Date();
        window.localStorage.setItem('comment-ask', now.toISOString());
        if (user?.created) {
          const differenceInDays = (now.getTime() - new Date(user.created ?? "").getTime()) / (1000 * 60 * 60 * 24);
          if (differenceInDays > 7) {

            // setShowCommentBox(true)
          }
        }
      } else {
        const lastAskStr = window.localStorage.getItem('comment-ask');

        const lastAsk = new Date(lastAskStr ?? "");
        const now = new Date();

        // Calculate the difference in days
        const differenceInDays = (now.getTime() - lastAsk.getTime()) / (1000 * 60 * 60 * 24);

        if (differenceInDays > 14) {
          window.localStorage.setItem('comment-ask', now.toISOString());
          AnalyticsHelper.logEvent(AnalyticsActions.modal_open, AnalyticsCategories.dashboard, "comment_box")
          // setShowCommentBox(true)
        }

      }
    } catch (e) {
    }

  }, [user])

  useEffect(() => {
    _fetchRecentAlert()
  }, [])

  const _fetchRecentAlert = async () => {
    const results = await alertService.searchAlerts(1, undefined, undefined, 1)
    if (results?.alerts?.docs?.length > 0) {
      setCurrentAlert(results.alerts?.docs[0])
    }

    const eRes = await eventService.getTop3()
    if (eRes.events) {
      setEvents(eRes.events)
    }

    setLoading(false)
  }

  const _finishWelcome = () => {
    const tempUser: CarnivoreUser = JSON.parse(JSON.stringify(user))
    tempUser.isOnboarded = true
    userService.updateUser({ isOnboarded: true }).then(res => {
      setUser(res.user)
    })
    setShowWelcome(false)
  }
  return (
    <Container>
      <Typography variant='h5'>Dashboard</Typography>
      <StyleHelper.DoubleVerticalSpace />
      {banner && (
        <Paper elevation={1} sx={{ mb: 3 }}>
          <Box p={3}>
            <Grid container spacing={1} alignItems={'center'}>
              <Grid item xs={4} lg={1}>
                <Box
                  width={50}
                  display={'flex'}
                  flexDirection={'column'}
                  justifyContent={'center'}
                >
                  <CarnivoreLogo />
                </Box>
              </Grid>
              <Grid item xs={8} lg={10}>
                <Typography
                  variant='subtitle2'
                  fontWeight={'bold'}
                  color={'primary'}
                >Important Message</Typography>
                <Typography variant='subtitle1' fontWeight={'bold'}>
                  {banner?.title}
                </Typography>
                <Typography variant='body1'>{banner?.msg}</Typography>
              </Grid>
            </Grid>
          </Box>
        </Paper>
      )}
      <Grid container spacing={1}>
        <Grid item xs={12} lg={8}>
          <Typography variant='h6' pl={1}>
            Quick Links
          </Typography>
          <Paper elevation={3} sx={{ m: 1, p: 2, }}>
            <Grid container p={3} spacing={3} flexWrap={'wrap'} height={'100%'} justifyContent={'center'}>
              {DASHBOARD_QUICK_LINKS.map((link, index) => (
                <Grid item xs={12} md={4} key={index}>
                  <DashboardLinkView link={link} />
                </Grid>
              ))}
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={12} lg={4}>
          <Typography variant='h6' pl={1}>
            Most Recent Alert
          </Typography>
          {loading && <AlertViewLoadingState />}
          {!loading && currentAlert && (
            <AlertView
              hideIcon={true}
              alert={currentAlert}
              key={currentAlert.id}
              showAlert={toggleShowAlertModal}
            />
          )}
          <StyleHelper.VerticalSpace />
          {loading && <Skeleton width={"100$"} height={'50'} />}
          {!loading && events && events.map(ev => <CarnivoreEventRow event={ev} key={ev.id} />)}
          <StyleHelper.VerticalSpace />

          <PortfolioReturn />
        </Grid>
      </Grid>

      <StyleHelper.DoubleVerticalSpace />

      {!loading && currentAlert && (
        <ViewAlertModal
          open={showAlertModal}
          onClose={toggleShowAlertModal}
          alert={currentAlert}
          size='lg'
        />
      )}
      <WelcomeModal open={showWelcome} size='lg' onClose={_finishWelcome} />
      <AlertModal message='' open={showCommentBox} size='md' customActionText='Leave Feedback' header="We'd love to hear your feedback" onClose={() => setShowCommentBox(false)} customAction={async () => { setShowCommentModal(true) }} customContent={<Box>
        <Typography variant='body2'>How are you liking the new Carnivore experience so far? We'd love to hear your suggestions, comments, or concerns.</Typography>
        <StyleHelper.VerticalSpace />
        <Typography variant='body2'>Have you also setup your browser notifications yet? Stay up to date with alerts right from your desktop!</Typography>
        <StyleHelper.VerticalSpace />
        <WebPush btnDisplay btnText='Manage Browser Alerts' />

      </Box>} />
      <CommentModal
        size='md'
        open={showCommentModal}
        onClose={() => setShowCommentModal(false)}
      />
    </Container>
  )
}
